/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { createRenderable } from '../renderable';
import { createGraphicsRenderItem } from '../webgl/render-item';
import { GlobalUniformSchema, BaseSchema, AttributeSpec, DefineSpec, InternalSchema, SizeSchema, ElementsSpec, GlobalTextureSchema } from './schema';
import { ValueCell } from '../../mol-util';
import { LinesShaderCode } from '../shader-code';
export var LinesSchema = __assign(__assign(__assign({}, BaseSchema), SizeSchema), {
  aGroup: AttributeSpec('float32', 1, 0),
  aMapping: AttributeSpec('float32', 2, 0),
  aStart: AttributeSpec('float32', 3, 0),
  aEnd: AttributeSpec('float32', 3, 0),
  elements: ElementsSpec('uint32'),
  dLineSizeAttenuation: DefineSpec('boolean'),
  dDoubleSided: DefineSpec('boolean'),
  dFlipSided: DefineSpec('boolean')
});
export function LinesRenderable(ctx, id, values, state, materialId) {
  var schema = __assign(__assign(__assign(__assign({}, GlobalUniformSchema), GlobalTextureSchema), InternalSchema), LinesSchema);

  var internalValues = {
    uObjectId: ValueCell.create(id)
  };
  var shaderCode = LinesShaderCode;
  var renderItem = createGraphicsRenderItem(ctx, 'triangles', shaderCode, schema, __assign(__assign({}, values), internalValues), materialId);
  return createRenderable(renderItem, values, state);
}